import { Component, Input } from '@angular/core';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-stopwatch-form-field',
  templateUrl: './stopwatch-form-field.component.html',
  styleUrls: ['./stopwatch-form-field.component.css'],
  standalone: false,
})
export class StopwatchFormFieldComponent extends DataTypeComponent {
  @Input() override data: any;

  @Input() override fieldConfig: FieldConfigDTO;
}
